

export const isNullOrWhitespace = (text: string): boolean =>
{
    if(text !== undefined && text.trim().length > 0)
    {
        return false;
    }

    return true;
}
